module.exports = __webpack_public_path__ + "static/media/banner3_dark.62225302.png";